/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../location-search-panel/location-search-panel.component.ngfactory';
import * as import2 from '@angular/common';
import * as import3 from '../location-search-panel/location-search-panel.component';
import * as import4 from '../../notification/notification.service';
import * as import5 from '../../orchestration/responsive.directive';
import * as import6 from '../../orchestration/responsive.service';
import * as import7 from '../../orchestration/navigation.service';
import * as import8 from 'ng2-translate/src/translate.pipe';
import * as import9 from 'ng2-translate/src/translate.service';
import * as import10 from '../../buttons/link/link.component.ngfactory';
import * as import11 from '../../buttons/link/link.component';
import * as import12 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import13 from '../../buttons/icon-button/icon-button.component';
import * as import14 from '../../notification/message/message.component.ngfactory';
import * as import15 from '../../notification/message/message.component';
import * as import16 from '../order-type-selection-panel/order-type-selection-panel.component.ngfactory';
import * as import17 from '../order-type-selection-panel/order-type-selection-panel.component';
import * as import18 from '../ordering-context.model';
import * as import19 from '../../inputs/text-field/text-field.component.ngfactory';
import * as import20 from '@angular/forms';
import * as import21 from '../../inputs/text-field/text-field.component';
import * as import22 from '../../inputs/decimal-field/decimal-field.component.ngfactory';
import * as import23 from '../../inputs/decimal-field/decimal-field.component';
import * as import24 from '../../inputs/form/form.component.ngfactory';
import * as import25 from '../../inputs/form/form.component';
import * as import26 from '../../inputs/phone-number-field/phone-number-field.component.ngfactory';
import * as import27 from '../../inputs/phone-number-field/phone-number.directive';
import * as import28 from '../../inputs/phone-number-field/phone-number-field.component';
import * as import29 from '../../inputs/selector-control/selector-control.component.ngfactory';
import * as import30 from '../../inputs/selector-control/selector-control.component';
import * as import31 from '../../inputs/form/field-pair/field-pair.component.ngfactory';
import * as import32 from '../../inputs/form/field-pair/field-pair.component';
import * as import33 from '../../inputs/text-area-field/text-area-field.component.ngfactory';
import * as import34 from '../../inputs/text-area-field/text-area-field.component';
import * as import35 from '../../store/store-details-panel/store-details-panel.component.ngfactory';
import * as import36 from '../../store/store-details-panel/store-details-panel.component';
import * as import37 from '../../orchestration/session.model';
import * as import38 from '../../buttons/button/button.component.ngfactory';
import * as import39 from '../../buttons/button/button.component';
import * as import40 from '../../page-layout/page-footer-control.directive';
import * as import41 from '../../html-utils/group-by.pipe';
import * as import42 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import43 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import44 from '../../orchestration/page';
import * as import45 from './ordering-context-selection-page.component';
import * as import46 from '../../qr-code-reader/qr-code-reader.service';
import * as import47 from '../../native-waiter-app.service';
import * as import48 from '../chewzie-table-lookup.service';
import * as import49 from '@angular/http';
import * as import50 from '@fedelta-pos/data-client/configuration/local-configuration.service';
import * as import51 from '../../store/store-search.model';
import * as import52 from '../../orchestration/navigation-params';
import * as import53 from '../../store/geolocate';
import * as import54 from '../../ui-elements/loading/loading.service';
import * as import55 from '../integrated-delivery-address-validation.service';
import * as import56 from '../../beacon/beacon-search.model';
import * as import57 from '../../config-support/param-config.service';
import * as import58 from '../../identity/identity.model';
import * as import59 from '@fedelta-pos/data-client/resource/search/search.model';
import * as import60 from '@fedelta-pos/data-client/resource/search/abstract-search.model';
const styles_OrderingContextSelectionPageComponent:any[] = ([] as any[]);
export const RenderType_OrderingContextSelectionPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingContextSelectionPageComponent,
  data: {}
}
);
function View_OrderingContextSelectionPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-location-search-panel',[
      [
        'class',
        'store-header-address-search'
      ]
      ,
      [
        'id',
        'location-search-input'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onSelect'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSelect' === en)) {
        const pd_0:any = ((<any>co.locationSelected($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_LocationSearchPanelComponent_0,import1.RenderType_LocationSearchPanelComponent)),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-order-type-options']),
    import0.ɵdid(114688,(null as any),0,import3.LocationSearchPanelComponent,[
      import0.NgZone,
      import4.NotificationService
    ]
    ,{
      accuracy: [
        0,
        'accuracy'
      ]
      ,
      latitude: [
        1,
        'latitude'
      ]
      ,
      longitude: [
        2,
        'longitude'
      ]

    }
    ,{onSelect: 'onSelect'}),
    import0.ɵdid(737280,(null as any),0,import5.ResponsiveDirective,[
      import0.ElementRef,
      import6.ResponsiveService,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'store-header-address-search';
    const currVal_1:any = ck(v,2,0,co.showStoreOrderTypeOptions);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ((co.position == null)? (null as any): ((co.position.coords == null)? (null as any): co.position.coords.accuracy));
    const currVal_3:any = ((co.position == null)? (null as any): ((co.position.coords == null)? (null as any): co.position.coords.latitude));
    const currVal_4:any = ((co.position == null)? (null as any): ((co.position.coords == null)? (null as any): co.position.coords.longitude));
    ck(v,3,0,currVal_2,currVal_3,currVal_4);
    ck(v,4,0);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),20,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'store-header-delivery-address-title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'store-header-delivery-address-title-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[
      [
        'class',
        'store-header-delivery-address-title-link'
      ]
      ,
      [
        'id',
        'delivery-address-change-link'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.editDeliveryAddress()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'store-header-delivery-address-details'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.editDeliveryAddress($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'store-header-delivery-address-details-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'store-header-delivery-address-details-action'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.clearDeliveryAddress()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import12.View_IconButtonComponent_0,import12.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import13.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = 'woa.button.ordering-context.changeDeliveryAddress';
    ck(v,9,0,currVal_1);
    const currVal_6:any = co.IconButtonType.CLOSE;
    ck(v,18,0,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform('woa.label.ordering-context.deliveringTo'));
    ck(v,5,0,currVal_0);
    const currVal_2:any = co.formattedDeliveryAddress;
    ck(v,15,0,currVal_2);
    const currVal_3:any = import0.ɵnov(v,18).type;
    const currVal_4:any = import0.ɵnov(v,18).disabled;
    const currVal_5:any = import0.ɵnov(v,18).unavailable;
    ck(v,17,0,currVal_3,currVal_4,currVal_5);
  });
}
function View_OrderingContextSelectionPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',[[
        'class',
        'store-header-delivery-address-error'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,6,{links: 1}),
    import0.ɵpod(['storeName'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.deliveryAddressError;
    const currVal_10:any = ck(v,3,0,((co.addressErrorStore == null)? (null as any): co.addressErrorStore.name));
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[
      [
        'class',
        'store-header-delivery-address'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import2.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-order-type-options']),
    import0.ɵdid(737280,(null as any),0,import5.ResponsiveDirective,[
      import0.ElementRef,
      import6.ResponsiveService,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'store-header-delivery-address';
    const currVal_1:any = ck(v,2,0,co.showStoreOrderTypeOptions);
    ck(v,1,0,currVal_0,currVal_1);
    ck(v,3,0);
    const currVal_2:any = co.showDeliveryAddressInHeader;
    ck(v,6,0,currVal_2);
    const currVal_3:any = co.deliveryAddressError;
    ck(v,9,0,currVal_3);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_AHEAD)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-type.orderAhead';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_DELIVERY)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-type.delivery';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.changeOrderType(co.OrderType.ORDER_AT_TABLE)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.show-store-type.orderAtTable';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[
      [
        'class',
        'store-header-options'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import5.ResponsiveDirective,[
      import0.ElementRef,
      import6.ResponsiveService,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = (co.canOrderAhead && (co.orderType !== co.OrderType.ORDER_AHEAD));
    ck(v,4,0,currVal_0);
    const currVal_1:any = (co.canOrderDelivery && (co.orderType !== co.OrderType.ORDER_DELIVERY));
    ck(v,7,0,currVal_1);
    const currVal_2:any = (co.canOrderAtTable && (co.orderType !== co.OrderType.ORDER_AT_TABLE));
    ck(v,10,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[
      [
        'class',
        'store-header'
      ]
      ,
      [
        'slot',
        'header'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import5.ResponsiveDirective,[
      import0.ElementRef,
      import6.ResponsiveService,
      import7.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = co.showAddressSearchInHeader;
    ck(v,4,0,currVal_0);
    const currVal_1:any = (co.showDeliveryAddressInHeader || co.deliveryAddressError);
    ck(v,7,0,currVal_1);
    const currVal_2:any = co.showStoreOrderTypeOptions;
    ck(v,10,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,7,{links: 1}),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),1,1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.load()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_LinkComponent_0,import10.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        7,
        4
      ]
      ],0,import11.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted(0,['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.error.common.loadFailed';
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = 'woa.button.common.reload';
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-type-selection-panel',[[
        'class',
        'order-type-selection'
      ]
      ],(null as any),[[
        (null as any),
        'onOrderTypeSelected'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onOrderTypeSelected' === en)) {
        const pd_0:any = ((<any>co.orderTypeSelected($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import16.View_OrderTypeSelectionPanelComponent_0,import16.RenderType_OrderTypeSelectionPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import17.OrderTypeSelectionPanelComponent,[import18.OrderingContextModel],{
      intention: [
        0,
        'intention'
      ]
      ,
      canOrderAtTable: [
        1,
        'canOrderAtTable'
      ]
      ,
      canOrderAhead: [
        2,
        'canOrderAhead'
      ]
      ,
      canOrderDelivery: [
        3,
        'canOrderDelivery'
      ]

    }
    ,{onOrderTypeSelected: 'onOrderTypeSelected'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.orderingContext.intention;
    const currVal_1:any = co.canOrderAtTable;
    const currVal_2:any = co.canOrderAhead;
    const currVal_3:any = co.canOrderDelivery;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-text-field',[
      [
        'name',
        'manualTableCode'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.manualTableCode = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.setTableCodeLookupCodeMsg((undefined as any))) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_TextFieldComponent_0,import19.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import21.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      maxlength: [
        1,
        'maxlength'
      ]
      ,
      spellcheck: [
        2,
        'spellcheck'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import21.TextFieldComponent]),
      import0.ɵdid(671744,[[
        8,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = '';
    ck(v,1,0,currVal_9);
    const currVal_10:any = '10';
    ck(v,2,0,currVal_10);
    const currVal_11:any = 'woa.label.ordering-context.enterTableNumber';
    const currVal_12:any = '10';
    const currVal_13:any = false;
    ck(v,4,0,currVal_11,currVal_12,currVal_13);
    const currVal_14:any = 'manualTableCode';
    const currVal_15:any = co.manualTableCode;
    ck(v,6,0,currVal_14,currVal_15);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_1:any = (import0.ɵnov(v,2).maxlength? import0.ɵnov(v,2).maxlength: (null as any));
    const currVal_2:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_OrderingContextSelectionPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-decimal-field',[
      [
        'name',
        'manualTableCode'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        8,
        'spellcheck',
        0
      ]
      ,
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.manualTableCode = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.setTableCodeLookupCodeMsg((undefined as any))) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import22.View_DecimalFieldComponent_0,import22.RenderType_DecimalFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import23.DecimalFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      maxlength: [
        1,
        'maxlength'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import23.DecimalFieldComponent]),
      import0.ɵdid(671744,[[
        8,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_10:any = '';
    ck(v,1,0,currVal_10);
    const currVal_11:any = '10';
    ck(v,2,0,currVal_11);
    const currVal_12:any = 'woa.label.ordering-context.enterTableNumber';
    const currVal_13:any = '10';
    ck(v,4,0,currVal_12,currVal_13);
    const currVal_14:any = 'manualTableCode';
    const currVal_15:any = co.manualTableCode;
    ck(v,6,0,currVal_14,currVal_15);
  },(ck,v) => {
    const currVal_0:any = false;
    const currVal_1:any = (import0.ɵnov(v,1).required? '': (null as any));
    const currVal_2:any = (import0.ɵnov(v,2).maxlength? import0.ɵnov(v,2).maxlength: (null as any));
    const currVal_3:any = import0.ɵnov(v,8).ngClassUntouched;
    const currVal_4:any = import0.ɵnov(v,8).ngClassTouched;
    const currVal_5:any = import0.ɵnov(v,8).ngClassPristine;
    const currVal_6:any = import0.ɵnov(v,8).ngClassDirty;
    const currVal_7:any = import0.ɵnov(v,8).ngClassValid;
    const currVal_8:any = import0.ɵnov(v,8).ngClassInvalid;
    const currVal_9:any = import0.ɵnov(v,8).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
  });
}
function View_OrderingContextSelectionPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,10,{links: 1}),
    import0.ɵpod(['lookupCode'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.tableLookupCodeMsg;
    const currVal_10:any = ck(v,3,0,co.tableLookupCode);
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'woa-form',([] as any[]),(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.acceptTableCode()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import24.View_FormComponent_0,import24.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import25.FormComponent,[import4.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,8,{models: 1}),
    import0.ɵqud(603979776,9,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import25.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import25.FormComponent]),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingContextSelectionPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingContextSelectionPageComponent_16)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingContextSelectionPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.allowAlphaTableCodes;
    ck(v,7,0,currVal_0);
    const currVal_1:boolean = !co.allowAlphaTableCodes;
    ck(v,10,0,currVal_1);
    const currVal_2:any = co.tableLookupCodeMsg;
    ck(v,13,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
      ,{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵqud(603979776,11,{links: 1})
  ]
  ,(ck,v) => {
    const currVal_8:any = 'woa.message.ordering-context.scanTable';
    ck(v,1,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,12,{links: 1}),
    import0.ɵpod(['lookupCode'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.tableLookupCodeMsg;
    const currVal_10:any = ck(v,3,0,co.tableLookupCode);
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,13,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.tableCodeScannerMsg;
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_19)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_20)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_21)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.tableLookupCodeMsg && !co.tableCodeScannerMsg);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.tableLookupCodeMsg;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.tableCodeScannerMsg;
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'table-selection-qr-guideline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'table-selection-qr-guideline-top-left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'table-selection-qr-guideline-top-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'table-selection-qr-guideline-bottom-left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'table-selection-qr-guideline-bottom-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_OrderingContextSelectionPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'table-selection'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,[
      [
        3,
        0
      ]
      ,
      [
        'containerQrCode',
        1
      ]

    ]
      ,(null as any),0,'video',[[
        'class',
        'table-selection-qr-code-web-video'
      ]
      ],[[
        8,
        'hidden',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_22)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.tableSelectionMethod === co.TableLookupMethod.MANUAL) && !co.tableCodeScanning);
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.tableCodeScannerExists && !co.tableCodeScanning);
    ck(v,6,0,currVal_1);
    const currVal_3:any = ((co.tableCodeScanning && (co.tableSelectionMethod === co.TableLookupMethod.QR_CODE)) && !co.hideTableCodeQrScanner);
    ck(v,12,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.hideTableCodeQrScanner;
    ck(v,9,0,currVal_2);
  });
}
function View_OrderingContextSelectionPageComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'woa-phone-number-field',[
      [
        'name',
        'orderMobilePhone'
      ]
      ,
      [
        'woa-phone-number',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.orderMobilePhone = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.deliveryDetailsChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import26.View_PhoneNumberFieldComponent_0,import26.RenderType_PhoneNumberFieldComponent)),
    import0.ɵdid(16384,(null as any),0,import27.PhoneNumberDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import27.PhoneNumberDirective]),
      import0.ɵdid(180224,(null as any),0,import28.PhoneNumberFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import28.PhoneNumberFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = 'woa.label.common.mobile';
    ck(v,3,0,currVal_7);
    const currVal_8:any = 'orderMobilePhone';
    const currVal_9:any = co.orderMobilePhone;
    ck(v,5,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,7).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,7).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,7).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,7).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,7).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,7).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,7).ngClassPending;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_OrderingContextSelectionPageComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',([] as any[]),[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>(co.saveForMember = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('selectedChange' === en)) {
        const pd_1:any = ((<any>co.saveDeliveryAddressForMemberChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import29.View_SelectorControlComponent_0,import29.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import30.SelectorControlComponent,([] as any[]),{
      selected: [
        0,
        'selected'
      ]
      ,
      label: [
        1,
        'label'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,{selectedChange: 'selectedChange'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.saveForMember;
    const currVal_3:any = (co.addressMatchesMember? 'woa.label.address.matchesMember': 'woa.label.address.saveForMember');
    const currVal_4:any = co.addressMatchesMember;
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_OrderingContextSelectionPageComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),65,'woa-form',[[
        'class',
        'delivery-address-entry'
      ]
      ],(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.confirmDeliveryAddress()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import24.View_FormComponent_0,import24.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import25.FormComponent,[import4.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,14,{models: 1}),
    import0.ɵqud(603979776,15,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import25.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import25.FormComponent]),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[
      [
        'name',
        'street'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.street = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.deliveryDetailsChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_TextFieldComponent_0,import19.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import21.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import21.TextFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[
      [
        'name',
        'city'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.city = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.deliveryDetailsChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_TextFieldComponent_0,import19.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import21.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import21.TextFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,23,'woa-field-pair',([] as any[]),(null as any),(null as any),(null as any),import31.View_FieldPairComponent_0,import31.RenderType_FieldPairComponent)),
    import0.ɵdid(49152,(null as any),0,import32.FieldPairComponent,([] as any[]),(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import32.FieldPairComponent]),
    (l()(),import0.ɵted(0,['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[
      [
        'name',
        'state'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.state = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.deliveryDetailsChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_TextFieldComponent_0,import19.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import21.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import21.TextFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[[
        'name',
        'postCode'
      ]
    ],[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'valueChange'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.postCode = $event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('valueChange' === en)) {
        const pd_1:any = ((<any>co.deliveryDetailsChanged()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_TextFieldComponent_0,import19.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import20.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import20.RequiredValidator,
      import20.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import21.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]
      ,
      spellcheck: [
        3,
        'spellcheck'
      ]

    }
    ,{valueChange: 'valueChange'}),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import21.TextFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingContextSelectionPageComponent_25)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,7,'woa-text-area-field',[[
        'name',
        'deliveryInstructions'
      ]
    ],[
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.deliveryInstructions = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import33.View_TextAreaFieldComponent_0,import33.RenderType_TextAreaFieldComponent)),
      import0.ɵdid(540672,(null as any),0,import20.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import20.MaxLengthValidator]),
      import0.ɵdid(180224,(null as any),0,import34.TextAreaFieldComponent,[import0.ChangeDetectorRef],{label: [
        0,
        'label'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import20.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import34.TextAreaFieldComponent]),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import20.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import20.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import20.NgControl,(null as any),[import20.NgModel]),
    import0.ɵdid(16384,(null as any),0,import20.NgControlStatus,[import20.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_OrderingContextSelectionPageComponent_26)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = '';
    ck(v,7,0,currVal_9);
    const currVal_10:any = '60';
    ck(v,8,0,currVal_10);
    const currVal_11:any = 'woa.label.address.street';
    const currVal_12:any = 'street-address';
    const currVal_13:any = '60';
    const currVal_14:any = false;
    ck(v,10,0,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_15:any = 'street';
    const currVal_16:any = co.street;
    ck(v,12,0,currVal_15,currVal_16);
    const currVal_26:any = '';
    ck(v,17,0,currVal_26);
    const currVal_27:any = '30';
    ck(v,18,0,currVal_27);
    const currVal_28:any = 'woa.label.address.suburb';
    const currVal_29:any = 'address-level2';
    const currVal_30:any = '30';
    const currVal_31:any = false;
    ck(v,20,0,currVal_28,currVal_29,currVal_30,currVal_31);
    const currVal_32:any = 'city';
    const currVal_33:any = co.city;
    ck(v,22,0,currVal_32,currVal_33);
    const currVal_43:any = '';
    ck(v,31,0,currVal_43);
    const currVal_44:any = '35';
    ck(v,32,0,currVal_44);
    const currVal_45:any = 'woa.label.address.state';
    const currVal_46:any = 'address-level1';
    const currVal_47:any = '35';
    const currVal_48:any = false;
    ck(v,34,0,currVal_45,currVal_46,currVal_47,currVal_48);
    const currVal_49:any = 'state';
    const currVal_50:any = co.state;
    ck(v,36,0,currVal_49,currVal_50);
    const currVal_60:any = co.sessionModel.currentApp.integratedDelivery;
    ck(v,41,0,currVal_60);
    const currVal_61:any = '10';
    ck(v,42,0,currVal_61);
    const currVal_62:any = 'woa.label.address.postCode';
    const currVal_63:any = 'postal-code';
    const currVal_64:any = '10';
    const currVal_65:any = false;
    ck(v,44,0,currVal_62,currVal_63,currVal_64,currVal_65);
    const currVal_66:any = 'postCode';
    const currVal_67:any = co.postCode;
    ck(v,46,0,currVal_66,currVal_67);
    const currVal_68:any = co.sessionModel.currentApp.showPhoneNumberForDelivery;
    ck(v,52,0,currVal_68);
    const currVal_77:any = '255';
    ck(v,55,0,currVal_77);
    const currVal_78:any = 'woa.label.address.deliveryInstructions';
    ck(v,57,0,currVal_78);
    const currVal_79:any = 'deliveryInstructions';
    const currVal_80:any = co.deliveryInstructions;
    ck(v,59,0,currVal_79,currVal_80);
    const currVal_81:boolean = (!co.identityModel.isGuestUser && co.identityModel.currentMember.allowProfileEdit);
    ck(v,64,0,currVal_81);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,7).required? '': (null as any));
    const currVal_1:any = (import0.ɵnov(v,8).maxlength? import0.ɵnov(v,8).maxlength: (null as any));
    const currVal_2:any = import0.ɵnov(v,14).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,14).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,14).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,14).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,14).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,14).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,14).ngClassPending;
    ck(v,6,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
    const currVal_17:any = (import0.ɵnov(v,17).required? '': (null as any));
    const currVal_18:any = (import0.ɵnov(v,18).maxlength? import0.ɵnov(v,18).maxlength: (null as any));
    const currVal_19:any = import0.ɵnov(v,24).ngClassUntouched;
    const currVal_20:any = import0.ɵnov(v,24).ngClassTouched;
    const currVal_21:any = import0.ɵnov(v,24).ngClassPristine;
    const currVal_22:any = import0.ɵnov(v,24).ngClassDirty;
    const currVal_23:any = import0.ɵnov(v,24).ngClassValid;
    const currVal_24:any = import0.ɵnov(v,24).ngClassInvalid;
    const currVal_25:any = import0.ɵnov(v,24).ngClassPending;
    ck(v,16,0,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25);
    const currVal_34:any = (import0.ɵnov(v,31).required? '': (null as any));
    const currVal_35:any = (import0.ɵnov(v,32).maxlength? import0.ɵnov(v,32).maxlength: (null as any));
    const currVal_36:any = import0.ɵnov(v,38).ngClassUntouched;
    const currVal_37:any = import0.ɵnov(v,38).ngClassTouched;
    const currVal_38:any = import0.ɵnov(v,38).ngClassPristine;
    const currVal_39:any = import0.ɵnov(v,38).ngClassDirty;
    const currVal_40:any = import0.ɵnov(v,38).ngClassValid;
    const currVal_41:any = import0.ɵnov(v,38).ngClassInvalid;
    const currVal_42:any = import0.ɵnov(v,38).ngClassPending;
    ck(v,30,0,currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42);
    const currVal_51:any = (import0.ɵnov(v,41).required? '': (null as any));
    const currVal_52:any = (import0.ɵnov(v,42).maxlength? import0.ɵnov(v,42).maxlength: (null as any));
    const currVal_53:any = import0.ɵnov(v,48).ngClassUntouched;
    const currVal_54:any = import0.ɵnov(v,48).ngClassTouched;
    const currVal_55:any = import0.ɵnov(v,48).ngClassPristine;
    const currVal_56:any = import0.ɵnov(v,48).ngClassDirty;
    const currVal_57:any = import0.ɵnov(v,48).ngClassValid;
    const currVal_58:any = import0.ɵnov(v,48).ngClassInvalid;
    const currVal_59:any = import0.ɵnov(v,48).ngClassPending;
    ck(v,40,0,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,currVal_59);
    const currVal_69:any = (import0.ɵnov(v,55).maxlength? import0.ɵnov(v,55).maxlength: (null as any));
    const currVal_70:any = import0.ɵnov(v,61).ngClassUntouched;
    const currVal_71:any = import0.ɵnov(v,61).ngClassTouched;
    const currVal_72:any = import0.ɵnov(v,61).ngClassPristine;
    const currVal_73:any = import0.ɵnov(v,61).ngClassDirty;
    const currVal_74:any = import0.ɵnov(v,61).ngClassValid;
    const currVal_75:any = import0.ɵnov(v,61).ngClassInvalid;
    const currVal_76:any = import0.ɵnov(v,61).ngClassPending;
    ck(v,54,0,currVal_69,currVal_70,currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76);
  });
}
function View_OrderingContextSelectionPageComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',[[
        'class',
        'table-ordering-message'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
    ,{
      text: [
        0,
        'text'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,16,{links: 1}),
    import0.ɵpod(['store'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = 'woa.message.ordering-context.tableOrderingNotAvailableNearestStore';
    const currVal_9:any = ck(v,3,0,co.nearestStoreName);
    ck(v,1,0,currVal_8,currVal_9);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-details-panel',[[
        'class',
        'stores-store'
      ]
    ],(null as any),[
      [
        (null as any),
        'onStoreDetails'
      ]
      ,
      [
        (null as any),
        'onOrderFromStore'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onStoreDetails' === en)) {
        const pd_0:any = ((<any>co.showStoreDetails(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onOrderFromStore' === en)) {
        const pd_1:any = ((<any>co.selectContext(v.context.$implicit,$event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import35.View_StoreDetailsPanelComponent_0,import35.RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import36.StoreDetailsPanelComponent,[
      import37.SessionModel,
      import6.ResponsiveService,
      import18.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,{
      store: [
        0,
        'store'
      ]
      ,
      intention: [
        1,
        'intention'
      ]
      ,
      filteredOrderType: [
        2,
        'filteredOrderType'
      ]
      ,
      showStoreImage: [
        3,
        'showStoreImage'
      ]
      ,
      showAddress: [
        4,
        'showAddress'
      ]
      ,
      showDescription: [
        5,
        'showDescription'
      ]
      ,
      collapseText: [
        6,
        'collapseText'
      ]

    }
    ,{
      onStoreDetails: 'onStoreDetails',
      onOrderFromStore: 'onOrderFromStore'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit;
    const currVal_1:any = co.orderingContext.intention;
    const currVal_2:any = co.orderType;
    const currVal_3:any = co.showStoreImage;
    const currVal_4:any = co.sessionModel.currentApp.showStoreAddrOnStoreSelection;
    const currVal_5:any = co.sessionModel.currentApp.showStoreDescOnStoreSelection;
    const currVal_6:any = co.collapseStoreText;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',[
      [
        'class',
        'stores-no-stores'
      ]
      ,
      [
        'id',
        'no-nearest-to-location-message'
      ]

    ]
    ,[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
      ,{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵqud(603979776,17,{links: 1})
  ]
  ,(ck,v) => {
    const currVal_8:any = 'woa.message.ordering-context.noNearestToLocation';
    ck(v,1,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',[
      [
        'class',
        'stores-no-stores'
      ]
      ,
      [
        'id',
        'no-nearest-to-you-message'
      ]

    ]
    ,[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
      ,{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵqud(603979776,18,{links: 1})
  ]
  ,(ck,v) => {
    const currVal_8:any = 'woa.message.ordering-context.noNearestToYou';
    ck(v,1,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',[
      [
        'class',
        'stores-no-stores'
      ]
      ,
      [
        'id',
        'no-nearest-delivery-message'
      ]

    ]
    ,[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_ContentMessageComponent_0,import14.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        4,
        4
      ]
    ],1,import15.ContentMessageComponent,[
      import0.ElementRef,
      import4.NotificationService
    ]
      ,{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵqud(603979776,19,{links: 1})
  ]
  ,(ck,v) => {
    const currVal_8:any = 'woa.message.ordering-context.noDeliveryStore';
    ck(v,1,0,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderingContextSelectionPageComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_31)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_32)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_33)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.location && !co.showDeliveryAddressInHeader);
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = (!co.location && !co.showDeliveryAddressInHeader);
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.showDeliveryAddressInHeader;
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'stores'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_29)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_30)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.ngIf;
    const currVal_1:any = co.trackStoreByFn;
    ck(v,5,0,currVal_0,currVal_1);
    const currVal_2:boolean = ((!v.context.ngIf.length && !co.isLoading) && co.hasLoaded);
    ck(v,8,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_36(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-details-panel',[[
        'class',
        'stores-store'
      ]
    ],(null as any),[
      [
        (null as any),
        'onStoreDetails'
      ]
      ,
      [
        (null as any),
        'onOrderFromStore'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onStoreDetails' === en)) {
        const pd_0:any = ((<any>co.showStoreDetails(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onOrderFromStore' === en)) {
        const pd_1:any = ((<any>co.selectContext(v.context.$implicit,$event)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import35.View_StoreDetailsPanelComponent_0,import35.RenderType_StoreDetailsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import36.StoreDetailsPanelComponent,[
      import37.SessionModel,
      import6.ResponsiveService,
      import18.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,{
      store: [
        0,
        'store'
      ]
      ,
      intention: [
        1,
        'intention'
      ]
      ,
      filteredOrderType: [
        2,
        'filteredOrderType'
      ]
      ,
      showStateWithName: [
        3,
        'showStateWithName'
      ]
      ,
      showDistance: [
        4,
        'showDistance'
      ]
      ,
      showStoreImage: [
        5,
        'showStoreImage'
      ]
      ,
      showAddress: [
        6,
        'showAddress'
      ]
      ,
      showDescription: [
        7,
        'showDescription'
      ]
      ,
      collapseText: [
        8,
        'collapseText'
      ]

    }
    ,{
      onStoreDetails: 'onStoreDetails',
      onOrderFromStore: 'onOrderFromStore'
    }
    )
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit;
    const currVal_1:any = co.orderingContext.intention;
    const currVal_2:any = co.orderType;
    const currVal_3:any = co.showStateWithName;
    const currVal_4:any = false;
    const currVal_5:any = co.showStoreImage;
    const currVal_6:any = co.sessionModel.currentApp.showStoreAddrOnStoreSelection;
    const currVal_7:any = co.sessionModel.currentApp.showStoreDescOnStoreSelection;
    const currVal_8:any = co.collapseStoreText;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_35(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_36)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.value;
    const currVal_1:any = co.trackStoreByFn;
    ck(v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_38(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[
      [
        'class',
        'stores-no-stores'
      ]
      ,
      [
        'id',
        'no-stores'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.ordering-context.noStores'));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextSelectionPageComponent_39(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[
      [
        'class',
        'stores-no-stores'
      ]
      ,
      [
        'id',
        'no-stores-in-location-message'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpod(['location']),
    import0.ɵpid(131072,import8.TranslatePipe,[
      import9.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform(co.noStoresInLocationMessage,ck(v,2,0,co.location.location)));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextSelectionPageComponent_37(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_38)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_39)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !co.location;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.location;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_34(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'stores'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingContextSelectionPageComponent_35)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    import0.ɵppd(2),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_37)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,5,0,ck(v,6,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),v.context.ngIf,'state'));
    const currVal_1:any = co.trackGroupStoreByFn;
    ck(v,5,0,currVal_0,currVal_1);
    const currVal_2:boolean = (!v.context.ngIf.length && !co.isLoading);
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_24)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_27)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_28)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_34)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showDeliveryAddressEntry;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showMessageTableOrderingNotAvailableNearestStore;
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.showNearestStores && co.filterStores(co.storeSearchModel.nearestStores));
    ck(v,9,0,currVal_2);
    const currVal_3:any = (co.showAllStores && co.filterStores(co.storeSearchModel.data));
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextSelectionPageComponent_23)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showOrderTypeSelection;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showTableSelection;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.showStoreSelection;
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_40(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'button-lookup'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import38.View_ButtonComponent_0,import38.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import39.ButtonComponent,[
      import0.ElementRef,
      import37.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        5,
        4
      ]
    ],0,import40.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.ordering-context.acceptTableNumber';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextSelectionPageComponent_41(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'button-enable-camera'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.enableTableCodeCamera()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import38.View_ButtonComponent_0,import38.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import39.ButtonComponent,[
      import0.ElementRef,
      import37.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        5,
        4
      ]
    ],0,import40.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.ordering-context.enableCamera';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextSelectionPageComponent_42(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'button-scan'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.startTableCodeScan()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import38.View_ButtonComponent_0,import38.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import39.ButtonComponent,[
      import0.ElementRef,
      import37.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        5,
        4
      ]
    ],0,import40.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.ordering-context.scan';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextSelectionPageComponent_43(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'button-stop-scan'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.stopTableCodeScan()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import38.View_ButtonComponent_0,import38.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import39.ButtonComponent,[
      import0.ElementRef,
      import37.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        5,
        4
      ]
    ],0,import40.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.ordering-context.stopScan';
    const currVal_28:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextSelectionPageComponent_44(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'delivery-address-entry-confirm-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import38.View_ButtonComponent_0,import38.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import39.ButtonComponent,[
      import0.ElementRef,
      import37.SessionModel,
      import0.ChangeDetectorRef,
      import6.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        5,
        4
      ]
    ],0,import40.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.deliveryAddressConfirmLabel;
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_OrderingContextSelectionPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import41.GroupByPipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(671088640,2,{form: 0}),
    import0.ɵqud(671088640,3,{containerQrCode: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),31,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import42.View_ModalPageLayoutComponent_0,import42.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import43.ModalPageLayoutComponent,[
      import44.Page,
      import7.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      showBackground: [
        2,
        'showBackground'
      ]
      ,
      customGeometry: [
        3,
        'customGeometry'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,4,{contentMessages: 1}),
    import0.ɵqud(603979776,5,{footerControls: 1}),
    import0.ɵpod(['storeName']),
    import0.ɵpid(131072,import2.AsyncPipe,[import0.ChangeDetectorRef]),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import44.PageLayout,(null as any),[import43.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),2,1,(null as any),View_OrderingContextSelectionPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,1,(null as any),View_OrderingContextSelectionPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderingContextSelectionPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextSelectionPageComponent_40)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextSelectionPageComponent_41)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextSelectionPageComponent_42)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextSelectionPageComponent_43)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_OrderingContextSelectionPageComponent_44)),
    import0.ɵdid(16384,(null as any),0,import2.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import45.OrderingContextSelectionPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = ck(v,8,0,((co.orderingContext.selectedStore == null)? (null as any): co.orderingContext.selectedStore.name));
    const currVal_2:boolean = !(((import0.ɵunv(v,5,2,import0.ɵnov(v,9).transform(co.responsiveService.mobile$)) && co.tableCodeScanning) && (co.tableSelectionMethod === co.TableLookupMethod.QR_CODE)) && co.isNativeCamera);
    const currVal_3:any = co.customGeometry;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_4:any = co.showStoreHeader;
    ck(v,13,0,currVal_4);
    const currVal_5:boolean = ((!co.isLoading && co.loadingFailed) && !co.storeSearchModel.data.length);
    ck(v,16,0,currVal_5);
    const currVal_6:boolean = ((!co.isLoading && !co.loadingFailed) && co.hasLoaded);
    ck(v,19,0,currVal_6);
    const currVal_7:any = ((((co.showTableSelection && (co.tableSelectionMethod === co.TableLookupMethod.MANUAL)) && !co.tableCodeScanning) && !co.selectedStoreForTable) && !co.selectedTable);
    ck(v,22,0,currVal_7);
    const currVal_8:any = (((co.showTableSelection && co.tableCodeScannerExists) && co.tableCodeScannerDenied) && co.canOpenSettings);
    ck(v,25,0,currVal_8);
    const currVal_9:any = (((((co.showTableSelection && co.tableCodeScannerExists) && !co.tableCodeScannerDenied) && !co.tableCodeScanning) && !co.selectedStoreForTable) && !co.selectedTable);
    ck(v,28,0,currVal_9);
    const currVal_10:any = ((co.showTableSelection && !co.tableCodeScannerDenied) && co.tableCodeScanning);
    ck(v,31,0,currVal_10);
    const currVal_11:any = co.showDeliveryAddressEntry;
    ck(v,34,0,currVal_11);
  },(null as any));
}
function View_OrderingContextSelectionPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'woa-ordering-context-selection-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderingContextSelectionPageComponent_0,RenderType_OrderingContextSelectionPageComponent)),
    import0.ɵprd(512,(null as any),import46.QrCodeReaderService,import46.QrCodeReaderService,[
      import6.ResponsiveService,
      import37.SessionModel,
      import47.NativeWaiterAppService
    ]
    ),
    import0.ɵprd(512,(null as any),import48.ChewzieTableLookupService,import48.ChewzieTableLookupService,[
      import49.Http,
      import50.LocalConfigurationService
    ]
    ),
    import0.ɵprd(512,(null as any),import51.StoreSearchModel,import51.StoreSearchModel,[
      import0.Injector,
      [
        2,
        import51.STORE_SEARCH_FILTER_PROVIDER
      ]

    ]
    ),
    import0.ɵdid(4308992,(null as any),0,import45.OrderingContextSelectionPageComponent,[
      import52.NavigationParams,
      import0.ElementRef,
      import7.NavigationService,
      import4.NotificationService,
      import0.ChangeDetectorRef,
      import53.GeolocateService,
      import54.LoadingService,
      import55.IntegratedDeliveryAddressValidationService,
      import46.QrCodeReaderService,
      import48.ChewzieTableLookupService,
      import56.BeaconSearchModel,
      import57.ParamConfigService,
      import47.NativeWaiterAppService,
      import58.IdentityModel,
      import37.SessionModel,
      import18.OrderingContextModel,
      import6.ResponsiveService,
      import51.StoreSearchModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import59.SearchModel,(null as any),[import51.StoreSearchModel]),
    import0.ɵprd(6144,(null as any),import60.AbstractSearchModel,(null as any),[import51.StoreSearchModel]),
    import0.ɵprd(6144,(null as any),import44.Page,(null as any),[import45.OrderingContextSelectionPageComponent])
  ]
  ,(ck,v) => {
    ck(v,4,0);
  },(null as any));
}
export const OrderingContextSelectionPageComponentNgFactory:import0.ComponentFactory<import45.OrderingContextSelectionPageComponent> = import0.ɵccf('woa-ordering-context-selection-page',import45.OrderingContextSelectionPageComponent,View_OrderingContextSelectionPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-selection-page/ordering-context-selection-page.component.ngfactory.ts